import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ResponsePackage } from '../models/util.model';
import { Role } from '../models/role.model';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + "role/";
  }

  getAll(onlyEnabled: boolean = false) { //Add true if you want to return only Enabled roles
    return this.http.get<ResponsePackage<any>>(`${this.pathApi}getAll/${onlyEnabled}`, { headers: this.headers, observe: 'response' });
  }
  delete(id:number) {
    return this.http.get<ResponsePackage<any>>(`${this.pathApi}delete/`+id, { headers: this.headers, observe: 'response' });
  }

  save(obj: Role) {
    return this.http.post<ResponsePackage<string>>(`${this.pathApi}save`, obj, { headers: this.headers, observe: 'response' });
  }

  getPermissions() {
    return this.http.get<ResponsePackage<any>>(`${this.pathApi}getPermissions`, { headers: this.headers, observe: 'response' });
  }
}
